import {
  useMemo,
  ReactNode,
  RefObject,
  isValidElement,
  cloneElement,
  createRef,
  Children,
} from 'react'

/**
 * Given the children of an element, return an array of refs to each child element
 **/

export const useChildRefs = (children: ReactNode) =>
  useMemo((): [ReactNode, RefObject<HTMLElement>[]] => {
    const refs: RefObject<HTMLElement>[] = []

    return [
      Children.map(children, child => {
        if (child && isValidElement(child)) {
          const ref = createRef<HTMLElement>()
          refs.push(ref)

          return cloneElement(child, { ref })
        } else {
          return child
        }
      }),
      refs,
    ]
  }, [children])
